import { Link } from 'react-router-dom';
import FadeInText from '../functionality/fadeIn';
import image from "../images/animated_image.png";
import "./About.css"; 
const About = () => 
{
    const downloadResume = () => {
      fetch('/DeandreCook_UpdatedResume1.docx')
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'DeandreCook_Resume.docx';
          a.click();
          window.URL.revokeObjectURL(url);
        });
    };
    return(                 
        <section id="about" className="about-section">
            <div className="about-container">
                <div className="about-content">
                    <FadeInText text={<h2>Full-Stack Software Engineer</h2>} count={100}/>
                    <FadeInText text={<p>Hi I'm DeAndre, I am a freelance Full-Stack Engineer building scalable SaaS platforms with .NET. </p>} count={1000}/>
                    <FadeInText text={<p>I Specializing in building scalable solutions for SaaS startups, small businesses, enterprises, and entrepreneurs. My passion is implementing efficient, elegant code and solving complex problems to drive business growth.</p>} count={2000}/>

                    <div className="skills">
                        <span>React JS</span>
                        <span>.NET APIs</span>
                        <span>SQL</span>
                        <span>C#</span>
                        <span>Azure Cloud Engineering</span>
                        <span>System Design</span>
                        <span>5+ years experience</span>
                        
                    </div>
                    <div className='buttons'>
                       <button className="cta" onClick={() => window.location.href = '#portfolio'}>View Work</button>
                        <Link to="https://calendly.com/drecook16/30min" ><button className="cta2">Book Consultation</button></Link>
                        <button className='cta' onClick={downloadResume}>Resume</button>
                    </div>
                </div>
                <div className="about-visual">
                    <div className="profile-card">
                        <div className='image-wrapper'>
                            <img src={image} alt="DeAndre Cook" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    );
}

export default About;
